import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PlatformState {
  private platformName?: string;
  private isNativePlatform?: boolean;

  private isAndroid = new BehaviorSubject<boolean>(false);
  private isIOS = new BehaviorSubject<boolean>(false);
  private isAndroidOrIOS = new BehaviorSubject<boolean>(false);
  private isWeb = new BehaviorSubject<boolean>(false);

  update() {
    this.platformName = Capacitor.getPlatform();
    this.isNativePlatform = Capacitor.isNativePlatform();

    this.isAndroid.next(this.isNativePlatform && this.platformName === 'android');
    this.isIOS.next(this.isNativePlatform && this.platformName === 'ios');
    this.isAndroidOrIOS.next(this.isAndroid.getValue() || this.isIOS.getValue());
    this.isWeb.next(this.isNativePlatform === false);
  }

  getIsAndroid() {
    return this.isAndroid.asObservable();
  }

  getIsIOS() {
    return this.isIOS.asObservable();
  }

  getIsAndroidOrIOS() {
    return this.isAndroidOrIOS.asObservable();
  }

  getIsWeb() {
    return this.isWeb.asObservable();
  }
}
